import { Link } from "react-router-dom";
import { Crown, Trophy } from "lucide-react";
import { mediaUrl } from "@/lib/upload";
import { fmtDate } from "@/lib/format";

/** Albo dei premi finali sulla home pubblica del torneo (solo se pubblicati dallo staff). */
export function FinalAwardsShowcase({ awards, slug, className = "" }) {
  if (!awards?.items?.length) return null;
  const champ = awards.items.find((i) => i.key === "campione");
  const others = awards.items.filter((i) => i !== champ);
  return (
    <section className={className} data-testid="final-awards-showcase">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div><div className="fsl-kicker">Albo d'oro</div><h2 className="font-display font-extrabold uppercase text-3xl sm:text-4xl leading-none mt-1">I premi finali</h2></div>
        {awards.published_at && <span className="text-xs text-fsl-slate num">{fmtDate(awards.published_at)}</span>}
      </div>
      {champ && (
        <div className="relative overflow-hidden grain rounded-2xl border-2 border-fsl-gold p-6 sm:p-8 mb-4 bg-[linear-gradient(135deg,rgba(244,174,43,0.28),rgba(4,30,50,0.95)_60%)] shadow-[0_24px_60px_rgba(0,0,0,0.5)]" data-testid="final-award-champion">
          <div className="absolute -right-6 -top-6 text-fsl-gold/10"><Trophy className="h-48 w-48" /></div>
          <div className="relative flex items-center gap-5">
            <span className="h-16 w-16 sm:h-20 sm:w-20 rounded-2xl bg-fsl-gold text-ink-950 inline-flex items-center justify-center shadow-lg shrink-0"><Trophy className="h-8 w-8 sm:h-10 sm:w-10" /></span>
            <div className="min-w-0"><div className="text-[10px] font-bold uppercase tracking-[0.2em] text-fsl-gold">{champ.title}</div><div className="font-display font-extrabold uppercase text-3xl sm:text-5xl leading-none mt-1 text-fsl-white">{champ.winner}</div>{champ.note && <p className="text-sm text-fsl-white/80 mt-2">{champ.note}</p>}</div>
          </div>
        </div>
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {others.map((i) => {
          const inner = (
            <>
              {i.photo_url ? <img src={mediaUrl(i.photo_url)} alt="" className="h-14 w-14 rounded-xl object-cover shrink-0" loading="lazy" /> : <span className="h-14 w-14 rounded-xl bg-fsl-gold/15 text-fsl-gold inline-flex items-center justify-center shrink-0"><Crown className="h-6 w-6" /></span>}
              <div className="min-w-0"><div className="text-[10px] font-bold uppercase tracking-[0.18em] text-fsl-gold">{i.title}</div><div className="font-display font-extrabold uppercase text-xl leading-tight mt-0.5 truncate">{i.winner}</div>{i.winner_sub && i.winner_sub !== "Squadra" && <div className="text-xs text-fsl-slate truncate">{i.winner_sub}</div>}{i.note && <p className="text-xs text-fsl-white/75 mt-1 line-clamp-2">{i.note}</p>}</div>
            </>
          );
          const cls = "fsl-card p-4 flex items-center gap-4 border-fsl-gold/30 hover:border-fsl-gold/70 transition-colors";
          return i.player_id ? <Link key={i.key} to={`/tornei/${slug}/giocatori/${i.player_id}`} className={cls} data-testid={`final-award-card-${i.key}`}>{inner}</Link> : <div key={i.key} className={cls} data-testid={`final-award-card-${i.key}`}>{inner}</div>;
        })}
      </div>
    </section>
  );
}
